var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeficit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02326 25V20.4043L1 16.5745V8.14893V0.999999H6.02326",
    stroke: "#FB2F2F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5348 25H25.5581V16.5745V8.14893L20.5348 4.57447V0.999999",
    stroke: "#FB2F2F",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0625 13.2814V10.745C18.0622 10.5488 18.01 10.3561 17.9112 10.1865C17.8124 10.0169 17.6705 9.87638 17.5 9.77923L13.5625 7.52473C13.3911 7.42708 13.1973 7.37573 13 7.37573C12.8027 7.37573 12.6089 7.42708 12.4375 7.52473L8.5 9.77867C8.15181 9.97836 7.9375 10.3468 7.9375 10.745V15.2552C7.9375 15.654 8.15181 16.0219 8.5 16.221L12.4375 18.4755C12.6089 18.5731 12.8027 18.6245 13 18.6245M13 18.6245C13.1973 18.6245 13.3911 18.5731 13.5625 18.4755M13 18.6245V13.0001M13 13.0001L17.9106 10.1651M13 13.0001L8.08938 10.1651M15.25 16.9376H18.625",
    stroke: "#FB2F2F",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 13.5,
    fill: "white",
    transform: "translate(6.25 6.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeficit);
export default __webpack_public_path__ + "static/media/deficit.37d41e773500ffdad18af9ebbd4271a6.svg";
export { ForwardRef as ReactComponent };